import { createPortal } from 'react-dom'

/**
 * Renders its children into `document.body`.
 *
 * Overlays are `position: fixed`, which is only viewport-relative while no
 * ancestor establishes a containing block. `AppHeader` paints itself with
 * `backdrop-filter`, and that alone makes it one — so a sheet opened from a
 * header action (the rules "i", the overflow menu's edit-name) was laid out
 * inside the 64px header box and clipped off the top of the screen. Portalling
 * out of the tree keeps `inset: 0` meaning the viewport.
 */
export function Portal({ children }: { children: React.ReactNode }) {
  return createPortal(children, document.body)
}
